module.exports = __webpack_public_path__ + "img/Restaurant2.f0ae801a.png";